export default {
	baseURL: 'https://stysoft.sftest.at'
}
